import React, { memo } from 'react';

interface Props {}

function ProfileAdditionalInfo() {
  return null;
}

export default memo(ProfileAdditionalInfo);
